import { Fragment } from 'react'
import { useParams } from 'react-router'
import { useTranslation } from 'react-i18next'
import { useFeature } from '@growthbook/growthbook-react'

import { ROUTE_PATH } from 'lib/paths'
import { MODAL_MODE } from 'components/Modal/config'
import { endpoints } from 'store/api/yay/user'
import { useModal } from 'store/slices/modals'
import { useIsSelfUser } from '../../lib/useIsSelfUser'
import { useGetGiftInventoryQuery } from 'store/api/yay/gifts'
import usePageModal from 'features/Modal/hooks/usePageModal'

import Nickname from 'components/Nickname'
import Button from 'components/Button'
import Ellipsis from 'components/Ellipsis'

import '../../style.scss'
import Avatar from 'components/Avatar'

const SelfGiftCountButton = ({ user }) => {
  // do not use this component when not logged in
  // the gift inventory query returns an error if not logged in
  const selfGiftInventoryRes = useGetGiftInventoryQuery()

  return (
    <Fragment>
      <Button
        icon="gift"
        buttonStyle="bordered-gray-without-bg-dark-text"
        className="User__profile__gift"
        to={ROUTE_PATH.USER_GIFTS(user?.id)}
      >
        {selfGiftInventoryRes.isSuccess &&
          (selfGiftInventoryRes.data?.total_count ?? 0).toLocaleString()}
      </Button>
    </Fragment>
  )
}

const UserInfo = () => {
  const { t } = useTranslation()
  const { generatePageModalUrl } = usePageModal()
  const params = useParams()

  const userRes = endpoints?.getUser?.useQueryState?.({
    userId: params?.userId,
  })

  const user = userRes?.data
  const isSelfUser = useIsSelfUser(user?.id)

  const isEmplGiftsEnabled = useFeature('yay-17610')?.on

  const userFollowerModal = useModal('UserFollowerModal')
  const userFollowingModal = useModal('UserFollowingModal')

  return (
    <>
      <Avatar
        user={user}
        wrapperClassName="User__profile__image__wrapper"
        showVipCircle={!user?.hide_vip && user?.vip}
        showOnlineStatus={true}
      />

      {isSelfUser &&
        user?.id && ( // show before everything else in renewed UI
          <div className="User__profile__buttons">
            {isEmplGiftsEnabled && <SelfGiftCountButton user={user} />}
            <Button
              icon="edit"
              buttonStyle="bordered-gray-without-bg-dark-text"
              className="User__profile__edit"
              bold
              to={generatePageModalUrl(MODAL_MODE.USER_EDIT)}
            >
              {t('common.edit')}
            </Button>
          </div>
        )}

      <h3 className="User__profile__h3">
        <Nickname user={user} />
      </h3>

      {!isSelfUser && user?.id && user?.followed_by && (
        <div className="User__profile__tag">
          <img src="/images/icon-account-checked.svg" width={14} />
          {t('common.follows_you')}
        </div>
      )}

      {user?.biography && (
        <Ellipsis>
          <p className="User__profile__p">{user?.biography}</p>
        </Ellipsis>
      )}

      <dl className="User__profile__dl">
        <Button
          className="User__profile__dl__item"
          onClick={() => userFollowerModal.open()}
          buttonStyle="none"
        >
          <dd>{(user?.followers_count ?? 0).toLocaleString()}</dd>
          <dt>{t('common.followers')}</dt>
        </Button>
        {isSelfUser && (
          <Button
            className="User__profile__dl__item"
            onClick={() => userFollowingModal.open()}
            buttonStyle="none"
          >
            <div className="User__profile__dl__item">
              <dd>{(user?.followings_count ?? 0).toLocaleString()}</dd>
              <dt>{t('common.followings')}</dt>
            </div>
          </Button>
        )}
      </dl>
    </>
  )
}

export default UserInfo
